import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

export const StyledMobileNav = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: '1 1 auto',
  [theme.breakpoints.up('md')]: {
    display: 'none'
  }
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/HamburgerMenu/styles.js